(function () {
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format || window.theme?.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function ensureWasEl(priceEl) {
    let wasEl = priceEl.querySelector("[data-tt-price-was]");
    if (!wasEl) {
      wasEl = document.createElement("span");
      wasEl.className = "tt-price__was";
      wasEl.setAttribute("data-tt-price-was", "");
      priceEl.appendChild(wasEl);
    }
    return wasEl;
  }

  function ensureBadgeEl(priceEl) {
    let badgeEl = priceEl.querySelector("[data-tt-price-badge]");
    if (!badgeEl) return null; // badge is optional; don’t auto-create if not present
    return badgeEl;
  }

  function updatePrice(priceEl, variantPrice) {
    const percent = parseFloat(priceEl.getAttribute("data-tt-discount-percent") || "0") || 0;
    const moneyFmt = window.theme?.moneyFormat || "{{amount}}";

    const original = variantPrice;
    const discounted = Math.floor(original * (100 - percent) / 100);

    const currentEl = priceEl.querySelector("[data-tt-price-current]");
    const wasEl = ensureWasEl(priceEl);
    const badgeEl = ensureBadgeEl(priceEl);

    if (percent > 0 && discounted < original) {
      if (currentEl) currentEl.textContent = formatMoney(discounted, moneyFmt);
      wasEl.textContent = formatMoney(original, moneyFmt);
      wasEl.style.display = "";

      if (badgeEl) {
        badgeEl.textContent = `${percent}% OFF`;
        badgeEl.style.display = "";
      }
    } else {
      if (currentEl) currentEl.textContent = formatMoney(original, moneyFmt);
      wasEl.style.display = "none";
      if (badgeEl) badgeEl.style.display = "none";
    }
  }

  function init() {
    const priceEls = document.querySelectorAll("[data-tt-price]");
    if (!priceEls.length) return;

    const form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector("product-form form");
    if (!form) return;

    const jsonEl = document.querySelector("[data-tt-variant-prices]");
    if (!jsonEl) return;

    let map = {};
    try {
      map = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    function refresh() {
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput ? idInput.value : null;
      if (!variantId || map[variantId] == null) return;

      const price = map[variantId];
      priceEls.forEach((el) => updatePrice(el, price));
    }

    form.addEventListener("change", refresh);
    document.addEventListener("variant:change", refresh);
    document.addEventListener("product:variant-change", refresh);

    refresh();
  }

  document.addEventListener("DOMContentLoaded", init);
})();
